import { render, staticRenderFns } from "./BackupCodesProvider.vue?vue&type=template&id=c0cb11e8&scoped=true&"
import script from "./BackupCodesProvider.vue?vue&type=script&lang=ts&"
export * from "./BackupCodesProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cb11e8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDialog,VDivider})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0cb11e8')) {
      api.createRecord('c0cb11e8', component.options)
    } else {
      api.reload('c0cb11e8', component.options)
    }
    module.hot.accept("./BackupCodesProvider.vue?vue&type=template&id=c0cb11e8&scoped=true&", function () {
      api.rerender('c0cb11e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/auth/BackupCodesProvider.vue"
export default component.exports